/*!*
 * @author yueheqin
 * @date 2019/10/16
 * @project zujuanzaixian
 * @desc 下载
 */
export const download = (url) => {
  let iframe = document.getElementById('#downloadIframe')
  if (iframe) {
    iframe.src = url
  } else {
    iframe = document.createElement('iframe')
    iframe.id = '#downloadIframe'
    iframe.style.display = 'none'
    iframe.src = url
    document.body.appendChild(iframe)
  }
}
